<template>

    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                    <div class="card-header card-header-info">
                        <h4 class="card-title ">Import Pelanggan</h4>
                    </div>
                    <div class="card-body">
                        <div class="form-group">
                            <p>Untuk mengimport pelanggan, donlod terlebih dahulu template format CSVnya</p>
                            <button class="btn btn-info" @click="downloadCSV()">Download File CSV</button>
                        </div>
                        <div class="form-group">
                            <p>Pastikan formatnya telah terbentuk dengan benar.</p>
                            <div class="alert alert-info"><strong class="text-danger">INFO :</strong> untuk tanggal tagihan cukup tulisan tiap tanggal berapa,misal tgl 15 ||  untuk data yang tidak cukup di kosongin || untuk paket dan area harus di setting manual di halaman admin ini hanya untuk import nama, telepon dan ppoe</div>
                            <div class="alert alert-warning"><strong class="text-danger">WARNING :</strong> Jangan ganti judul kolom pada template import, karena bisa menyebabkan data tidak terbaca dengan benar</div>
                        </div> 
                        <div class="form-groups">
                            <label for="csv_file" class="text-secondary">Pilih CSV File</label></br>
                            <input type="file" id="csv_file" name="csv_file" class="form-control" @change="loadCSV($event)" style="z-index: 0">
                        </div>
                    </div>
                    </div>
                </div>
                
                <div class="col-md-12">
                    <div class="alert alert-success" role="alert" v-show="imported > 0">
                        Total <strong>{{imported + " Pelanggan"}}</strong> Telah berhasil diinput.
                    </div>

                    <div class="card">
                        <div class="card-header card-header-info">
                            <h4 class="card-title ">Preview Dokumen</h4>
                        </div>
                        <div class="card-body">
                            
                            <div class="table-responsive">
                            <table class="table">
                                <thead class=" text-info">
                                    <th>Simpan</th>
                                    <th>No.</th>
                                    <th>Nama</th>
                                    <th>Telepon</th>
                                    <th>PPOE</th>
                                    <th>Tgl Tagihan</th>
                                    <th>Tambahan 1</th>
                                    <th>Biaya 1</th>
                                    <th>Tambahan 2</th>
                                    <th>Biaya 2</th>
                                    <th>Diskon</th>
                                    <th>Area</th>
                                    <th>Paket Nama</th>
                                    <th>Alamat</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(u, index) in parse_csv">
                                        <td>
                                            <button class="btn btn-sm btn-info" 
                                            @click="
                                            nama = u.nama,
                                            ppoe = u.ppoe,
                                            wa = u.telepon,
                                            tanggal = u.tanggal,
                                            rincian1 = u.tambahan,
                                            rincian2 = u.tambahan_2,
                                            biaya1 = u.biaya,
                                            biaya2 = u.biaya_2,
                                            diskon = u.diskon,
                                            area = u.area,
                                            paketnama = u.paket_nama,
                                            tarif = u.paket_tarif,
                                            alamat = u.alamat,
                                            lat = u.lat,
                                            lng = u.lng,
                                            Simpan(index)
                                            "
                                            ><i class="material-icons">save</i></button>
                                        </td>
                                        <td>{{ index+1 }}</td>
                                        <td>{{u.nama}}</td>
                                        <td>{{u.telepon}}</td>
                                        <td>{{u.ppoe}}</td>
                                        <td>{{u.tanggal}}</td>
                                        <td>{{u.tambahan}}</td>
                                        <td>{{ribu(u.biaya)}}</td>
                                        <td>{{u.tambahan_2}}</td>
                                        <td>{{ribu(u.biaya_2)}}</td>
                                        <td>{{ribu(u.diskon)}}</td>
                                        <td>{{u.area}}</td>
                                        <td>{{u.paket_nama}}<br>{{ribu(u.paket_tarif)}}</td>
                                        <td>{{u.alamat}}<br>{{u.lat}}<br>{{u.lng}}</td>
                                    </tr>
                                </tbody>
                            </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- MODAL -->
        <div class="modal" tabindex="-1" role="dialog" v-show="modalImport">
        <div class="overlay"></div>
        <div class="modal-dialog" role="document" style="width: 750px;max-width: 750px">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Rincian Data</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="modalImport = false">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="bmd-label-floating">Nama</label>
                            <input type="text" class="form-control" placeholder="Nama Area..." v-model="nama">
                        </div>
                        <div class="form-group">
                            <label class="bmd-label-floating">Telepon</label>
                            <input type="text" class="form-control" placeholder="Nama Area..." v-model="wa">
                        </div>
                        <div class="form-group">
                            <label class="bmd-label-floating">PPOE</label>
                            <input type="text" class="form-control" placeholder="Nama Area..." v-model="ppoe">
                        </div>
                        <div class="form-group">
                            <label class="bmd-label-floating">Tanggal Tagihan (Hanya Tanggal saja. Misal : 10 )</label>
                            <input type="number" class="form-control" placeholder="Tanggal Tagihan..." v-model="tanggal">
                        </div>
                        <div class="form-group">
                            <label class="bmd-label-floating">Tambahan 1</label>
                            <input type="text" class="form-control" placeholder="Rincian 1..." v-model="rincian1">
                            <input type="number" class="form-control" placeholder="Biaya 1..." v-model="biaya1">
                        </div>
                        <div class="form-group">
                            <label class="bmd-label-floating">Tambahan 2</label>
                            <input type="text" class="form-control" placeholder="Rincian 1..." v-model="rincian2">
                            <input type="number" class="form-control" placeholder="Biaya 1..." v-model="biaya2">
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="bmd-label-floating">Diskon</label>
                            <input type="number" class="form-control" placeholder="Diskon..." v-model="diskon">
                        </div>
                        <div class="form-group">
                            <label class="bmd-label-floating">Area</label>
                            <select class="form-control" id="exampleFormControlSelect1" placeholder="Pilih Resto..."  v-model="areaPilih">
                                <option value="" selected disabled>Pilih Area</option>
                                <option v-for="(u, index) in area" :value="u.id" >{{u.nama}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label class="bmd-label-floating">Tarif</label>
                            <select class="form-control" id="exampleFormControlSelect1" placeholder="Pilih Resto..."  v-model="tarifPilih">
                                <option value="" selected disabled>Pilih Paket</option>
                                <option v-for="(u, index) in tarif" :value="u.id" >{{u.nama+' @ '+ribu(u.tarif)}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <button class="btn btn-success" @click="Simpan(),modalImport = false">Simpan</button>
                        </div>
                    </div>
                    <!--
                    <div class="col-md-12">
                        <div class="table-responsive">
                        <table class="table">
                            <thead class=" text-info">
                            <th>No.</th>
                            <th>Nama</th>
                            <th>Jumlah</th>
                            <th>Aksi</th>
                            </thead>
                            <tbody>
                            <tr v-for="(u, index) in area">
                                <td>{{ index+1 }}</td>
                                <td>{{ u.nama }}</td>
                                <td>{{ u.jumlah }}</td>
                                <td>
                                <button class="btn btn-sm btn-primary" @click="pilihArea(u.id,u.nama);cariCustom()"> Pilih</button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        </div>
                    </div>
                    -->
                </div>
            </div>
            </div>
        </div>
        </div>
    </div>
</template>

<script>

import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'
import moment from 'moment'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { url } from '@/var/var.js'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 

var numeral = require("numeral");

Vue.use(moment)

export default {
	components: { 
		vuejsDatepicker,
		moment,
	}, 
  	data() {
		return {
			title: "Detail Servis",
			nama: '',
			ppoe: '',
			wa: '',
			area: [],
			tarif: [],
			tanggal: '',
			areaPilih: '',
			tarifPilih: '',
			rincian1: '',
			rincian2: '',
			biaya1: '',
			biaya2: '',
			diskon: '',
			area: '',
			paketnama: '',
			tarif: '',
            alamat: '',
            lat: '',
            lng: '',

            modalImport: false,
            imported: 0, // total yg telah di import

            
            channel_name: '',
            channel_fields: [],
            channel_entries: [],
            parse_header: [],
            parse_csv: [],
            sortOrders:{},
            sortKey: '',
            indexClicked: null
		}
	},
    filters: {
      capitalize: function (str) {
        return str.charAt(0).toUpperCase() + str.slice(1)
      }
    },
	methods: {
        sortBy: function (key) {
            var vm = this
            vm.sortKey = key
            vm.sortOrders[key] = vm.sortOrders[key] * -1
        },
        csvJSON(csv){
            var vm = this;
            // Bersihkan baris kosong dan pecah per baris
            var lines = csv.split("\n").filter(line => line.trim() !== "");
            var result = [];

            // 1. Ambil Header: Bersihkan karakter newline dan petik
            var headers = lines[0].replace(/(?:\\[rn]|[\r\n]|")+/g, "").split(",");
            
            vm.parse_header = headers;
            headers.forEach(key => {
                vm.sortOrders[key] = 1;
            });

            // 2. Looping data
            for (var i = 1; i < lines.length; i++) {
                var obj = {};
                
                /** * REGEX AJAIB: split koma, tapi abaikan koma di dalam tanda petik 
                 * Ini akan menjaga "-8,5069" tetap jadi satu kesatuan
                 **/
                var currentline = lines[i].split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/);

                headers.forEach((header, index) => {
                    let val = currentline[index] ? currentline[index].trim() : "";
                    
                    // Hapus tanda petik di awal/akhir nilai jika ada
                    val = val.replace(/^"|"$/g, "");

                    // KHUSUS KOORDINAT: Ubah koma menjadi titik agar bisa dibaca Maps
                    if (header === "lat" || header === "lng") {
                        val = val.replace(",", ".");
                    }

                    obj[header] = val;
                });

                result.push(obj);
            }

            return result;

            /*
            var vm = this
            var lines = csv.split("\n")
            var result = []
            //var headers = lines[0].replace(/(?:\\[rn]|[\r\n]+)+/g, "").split(",")
            var headers = lines[0].replace(/(?:\\[rn]|[\r\n]|")+/g, "").split(",")
            vm.parse_header = lines[0].split(",") 
            lines[0].split(",").forEach(function (key) {
                vm.sortOrders[key] = 1
            })
            
            lines.map(function(line, indexLine){
                if (indexLine < 1) return // Jump header line
                
                var obj = {}
                var currentline = line.split(",")
                
                headers.map(function(header, indexHeader){
                    var line = null;
                    if (currentline[indexHeader]) {
                        //line = currentline[indexHeader].replace(/(?:\\[rn]|[\r\n]+)+/g, "");;
                        line = currentline[indexHeader].replace(/(?:\\[rn]|[\r\n]|")+/g, "");;
                        //console.log(JSON.stringify(coba));
                    }
                    
                    obj[header] = line
                })
            
                result.push(obj)
            })
            
            result.pop() // remove the last item because undefined values
            
            return result // JavaScript object

            */
        },
        loadCSV(e) {
            var vm = this
            if (window.FileReader) {
                var reader = new FileReader();
                reader.readAsText(e.target.files[0]);
                // Handle errors load
                reader.onload = function(event) {
                    var csv = event.target.result;
                    vm.parse_csv = vm.csvJSON(csv)
                    
                    //console.log(JSON.stringify(vm.parse_csv));
                };
                reader.onerror = function(evt) {
                    if(evt.target.error.name == "NotReadableError") {
                        alert("Canno't read file !");
                    }
                };
            } else {
                alert('FileReader are not supported in this browser.');
            }
        },
		customFormatter (date) {
			return moment(date).format('DD');
		},
		getArea() {
			// for filter
			var data = new FormData();
			data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
			data.append('type', "all");
			data.append('bulan', "0");
			
            var apiUrl = inter.ListArea(); // 'ListArea';
			this.PostData(data,apiUrl).then(x => {
				if (x.status) {
				this.area = x.data;
				} else {
				//alert(x.pesan);
				}
			})
		},
		getTarif() {
            var data = {
                token: 'TangTung '+sessionStorage.getItem('myToken')
            }
			
			var apiUrl = inter.ListPaket();
			this.PostData(data,apiUrl).then(x => {
				if (x.status) {
				this.tarif = x.data;
				} else {
					//alert(x.pesan);
				}
			})
		},
        Simpan(index) {
            if (this.indexClicked == index) {
                return false;
            }

            this.indexClicked = index;

			if (this.tarif == "") {
				alert("Pilih Paket Terlebih dahulu");
				return false;
			}

			if (this.area == "") {
				alert("Pilih Area Terlebih dahulu");
				return false;
			}

			if (this.tanggal == "") {
				alert("Pilih Tanggal Terlebih dahulu");
				return false;
			}

			if (this.nama == "") {
				alert("Isikan Nama Terlebih dahulu");
				return false;
			}

			if (this.ppoe == "") {
				alert("Isikan PPOE Terlebih dahulu");
				return false;
			}

			if (this.wa == "") {
				alert("Isikan WA Terlebih dahulu");
				return false;
			}

			if (this.paketnama == "") {
				alert("Isikan Paket Nama Terlebih dahulu");
				return false;
			}
			
			/*
			var data = new FormData();
            data.append('token', );
            data.append('nama', this.nama);
            data.append('ppoe', this.ppoe);
            data.append('wa', this.wa);
			data.append('paket', this.tarifPilih);
			data.append('area', this.areaPilih);
			data.append('tanggal', moment(this.tanggal).format('DD'));
			*/
			var data = {
				token: 'TangTung '+sessionStorage.getItem('myToken'),
				nama: this.nama,
				ppoe: this.ppoe,
				wa: this.wa,
				paketnama: this.paketnama,
				tarif: this.tarif,
				area: this.area,
				rincian1: this.rincian1,
				rincian2: this.rincian2,
				diskon: this.diskon,
				biaya1: this.biaya1,
				biaya2: this.biaya2,
				tanggal: this.tanggal, //moment(this.tanggal).format('DD')
                alamat: this.alamat,
				lat: this.lat,
				lng: this.lng
			}

            this.loger(data);
			
      		var apiUrl = inter.PelangganImport();
            
			this.PostData(data,apiUrl).then(x => {
				this.loger(x);
				if (x.status) {
                    //location.href="#/pelanggan"
                    this.modalImport = false;
                    this.parse_csv.splice(index, 1);
                    this.imported = this.imported + 1;
				} else {
				    alert(x.pesan);
				}

                this.indexClicked = null;
			})
        },
        downloadCSV() {
            window.open('http://admin.beatcom.web.id/TEMPLATE_IMPORT_PELANGGAN.csv', '_blank');
        }
	},
	mounted() {
        document.title = "Import Pelanggan";

		this.getArea();
		this.getTarif();
	}
}
</script>

<style scoped>
.edit-input {
	font-size: 20pt !important;
}
.file-upload {
    opacity: 1 !important;
    position: relative !important;
    z-index: 0 !important;
}
.modal {
	display: inherit;
}
</style>


// WEBPACK FOOTER //
// src/components/pelanggan/import.vue